import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import {
  IconAlertComponent,
  IconComponent,
  IconTrashCanComponent,
} from '@pedix-workspace/angular-ui-icons';
import {
  CounterComponent,
  ProductResumePriceComponent,
} from '@pedix-workspace/pedixapp-shared-catalog';
import { UpsellHintComponent } from '@pedix-workspace/angular-ui-promotions';
import { UpsellHint } from '@pedix-workspace/shared-promotions';

@Component({
  selector: 'pxw-cart-order-item-row',
  templateUrl: './cart-order-item-row.component.html',
  styleUrls: ['./cart-order-item-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CounterComponent,
    IconAlertComponent,
    IconComponent,
    IconTrashCanComponent,
    ProductResumePriceComponent,
    TagComponent,
    UpsellHintComponent,
  ],
})
export class CartOrderItemRowComponent {
  readonly quantity = input.required<number>();
  readonly presentationLabel = input<string | undefined>(undefined);
  readonly presentationSku = input<string | undefined>(undefined);
  readonly displaySku = input.required<boolean>();
  readonly totalWithoutDiscount = input.required<number>();
  readonly total = input.required<number>();
  readonly readOnly = input(false);
  readonly availableStock = input<number | undefined>(undefined);
  readonly stockWarningLabel = input<string | undefined>(undefined);
  readonly showRemove = input.required<boolean>();
  readonly isOutOfStock = input.required<boolean>();
  readonly isCategoryAvailable = input.required<boolean>();
  readonly upsellHint = input<UpsellHint | undefined>(undefined);
  readonly removeLabel = input<string | null>(null);

  readonly qtyChange = output<number>();
  readonly remove = output<void>();

  onRemove(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.remove.emit();
  }
}
